import {
  AsyncLoadingSection,
  PageCard,
  PageCardRow,
  PageCardSection,
  SingleSectionPageCard,
  TaskPageHeaderLayout,
} from 'Components/Display';
import { SmartCheckboxList, SmartInputBlock } from 'Components/Form';
import { InputType } from 'Models/FormModels';
import { User } from 'Models/SharedModels';
import { PermissionCodesV3 } from 'Models/Authorization/permissionCodesV3';
import { ENDPOINTS } from 'Models/Templates/Routes/Routes';
import React, { Fragment } from 'react';
import { Row } from 'reactstrap';
import { SecureComponentV3 } from 'Components/Security/SecureComponentV3';
import {
  addEditTitle,
  buildRoute,
  defaultDataTransform,
  useAddEditSuccessHandler,
  useDataFetcher,
  useIdParam,
} from 'Utilities';

export const AddEditUser: React.FC = () => {
  const entityName = 'User';
  const [id, isAdd] = useIdParam();
  const handleSuccess = useAddEditSuccessHandler(entityName, isAdd);
  const [data, loadingStatus] = useDataFetcher<User>(
    buildRoute(ENDPOINTS.users.base, id),
    new User(),
    defaultDataTransform,
    User
  );

  return (
    <AsyncLoadingSection loadingStatus={loadingStatus} useMask>
      <TaskPageHeaderLayout
        title={addEditTitle(entityName, isAdd)}
        formProviderProps={{
          formModel: data,
          endpoint: ENDPOINTS.users.base,
          handleSuccess: handleSuccess,
        }}
      >
        <UsersAddEditFormContent />
      </TaskPageHeaderLayout>
    </AsyncLoadingSection>
  );
};

const UsersAddEditFormContent: React.FC = () => {
  return (
    <Fragment>
      <SingleSectionPageCard cardTitle="Details" centerContent inputSection>
        <Row>
          <SmartInputBlock
            name="username"
            label="Username"
            type={InputType.Text}
            required
          />
          <SmartInputBlock
            name="emailAddress"
            label="Email Address"
            type={InputType.Text}
            required
          />
          <SmartInputBlock
            name="phoneNumber"
            label="Phone Number"
            type={InputType.PhoneNumber}
          />
          <SmartInputBlock
            name="firstName"
            label="First Name"
            type={InputType.Text}
            required
          />
          <SmartInputBlock
            name="lastName"
            label="Last Name"
            type={InputType.Text}
            required
          />
        </Row>
      </SingleSectionPageCard>

      <PageCard>
        <PageCardRow>
          <PageCardSection title="V2 Roles">
            <SmartCheckboxList
              name="rolesList"
              labelField="name"
              checkedField="isSelected"
              groupField="groupName"
              hideCheckAll
            />
          </PageCardSection>
        </PageCardRow>
      </PageCard>

      <SecureComponentV3 permissions={[PermissionCodesV3.Role.Panel.View]}>
        <PageCard>
          <PageCardRow>
            <PageCardSection title="V3 Roles">
              <SmartCheckboxList
                name="v3RolesList"
                labelField="name"
                checkedField="isSelected"
                groupField="groupName"
                hideCheckAll
              />
            </PageCardSection>
          </PageCardRow>
        </PageCard>
      </SecureComponentV3>

      <PageCard>
        <PageCardRow>
          <PageCardSection title="Clients">
            <Row>
              <SmartCheckboxList
                name="clientList"
                labelField="name"
                checkedField="isSelected"
                groupField="groupName"
                hideCheckAll
              />
            </Row>
          </PageCardSection>
        </PageCardRow>
      </PageCard>
    </Fragment>
  );
};
